import seizureSafeIcon from "../icons/seizureSafeIcon.svg"
import blindIcon from "../icons/blindIcon.svg"
import visuallyImpairedIcon from "../icons/visuallyImpairedIcon.svg"
import adhdFriendlyIcon from "../icons/adhdFriendlyIcon.svg"
import cognitiveLearningIcon from "../icons/cognitiveLearningIcon.svg"
import motorImpairedIcon from "../icons/motorImpairedIcon.svg"

export interface IProfile {
    key: string;
    label: string;
    description: string;
    icon: string;
    settings: { [key: string]: any };
}

export const PROFILES: IProfile[] = [
    {
        key: 'seizure-safe',
        label: 'Seizure Safe Profile',
        description: 'Stops animations and reduces color saturation.',
        icon: seizureSafeIcon,
        settings: {
            'stop-animations': true,
            contrast: 'low-saturation',
        }
    },
    {
        key: 'blind',
        label: 'Blind Profile',
        description: 'Activates the screen reader for auditory navigation.',
        icon: blindIcon,
        settings: {
            'screen-reader': true,
            'image-tooltips': true,   // Read alt text aloud on hover
            'highlight-links': true,  // Screen readers navigate by links
        }
    },
    {
        key: 'visually-impaired',
        label: 'Visually Impaired Profile',
        description: 'Enhances contrast and readability for low vision.',
        icon: visuallyImpairedIcon,
        settings: {
            contrast: 'high-contrast',
            'font-size': 1.2,
            'big-cursor': true,
            'readable-font': true,
        }
    },
    {
        key: 'adhd-friendly',
        label: 'ADHD Friendly Profile',
        description: 'Reduces distractions for better focus.',
        icon: adhdFriendlyIcon,
        settings: {
            'readable-guide': true,
            'stop-animations': true,
            'hide-images': true,      // Remove visual noise
        }
    },
    {
        key: 'cognitive-learning',
        label: 'Cognitive & Learning Profile',
        description: 'Helpful tools for reading and comprehension.',
        icon: cognitiveLearningIcon,
        settings: {
            'readable-font': true,
            'highlight-title': true,
            'highlight-links': true,
            'letter-spacing': 1,      // Adds breathing room between letters
            'line-height': 1,         // More whitespace between lines
        }
    },
    {
        key: 'motor-impaired',
        label: 'Motor Impaired Profile',
        description: 'Optimizes the site for keyboard-only navigation.',
        icon: motorImpairedIcon,
        settings: {
            'super-focus': true,      // Vital — makes Tab key visible
            'highlight-links': true,  // Easier to spot clickable targets
            'big-cursor': true,
        }
    }
];
